import React, {useState} from 'react';
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {useSelector} from "react-redux";
import {Modal} from "react-bootstrap";
import FalconCloseButton from "../../../common/FalconCloseButton";
import BindItemsToOrganizationsForm from "../../organization-bindings/owner/BindItemsToOrganizationsForm";
import IconButton from "../../../common/IconButton";
import {faLock} from "@fortawesome/free-solid-svg-icons";

const BindItemsToOrganizationsModal = ({items}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    return (
        <>
            <IconButton icon={faLock}
                        onClick={handleShow}
                        variant="falcon-default"
                        size="sm"
                        className="m-1"
            >
                {t(lang, 'partners.common.items_access')}
            </IconButton>
            {show &&
                <Modal show={true} size="xl">
                    <Modal.Header>
                        <Modal.Title>{t(lang, 'partners.common.items_access')}</Modal.Title>
                        <FalconCloseButton onClick={handleClose}/>
                    </Modal.Header>
                    <Modal.Body>
                        <BindItemsToOrganizationsForm items={items}
                                                      handleClose={handleClose}
                        />
                    </Modal.Body>
                </Modal>
            }
        </>
    );
};

export default BindItemsToOrganizationsModal;